fourToldApp.controller("formCntrl", function (sharedService, $route, services, xmppAuth, esb, $scope, $cookieStore, $sce, $localStorage, $mdDialog, $window, $timeout, $filter, $mdToast, $location, templates, theme, $routeParams, cryptool) {
    var notification = JSON.parse($window.sessionStorage.getItem("dataNotification"));
    var data = notification.body;

    var xmppUser = $window.sessionStorage.getItem('userXmpp');
    var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
    var replyDate = JSON.parse($window.sessionStorage.getItem("replyDate"));
    var repliedBy = JSON.parse($window.sessionStorage.getItem("repliedBy"));
    $scope.theme = theme.getTheme();
    $scope.id = data.id;
    $scope.type_cs = notification.metadata.type;
    $scope.viewTemplate = $window.sessionStorage.getItem("viewTemplate");
    $scope.formHeader = notification.body.constraints.formHeader;
    $scope.formBody = notification.body.constraints.formBody;
    $scope.formats = ["dd-MMMM-yyyy", "dd-MM-yyyy", "dd.MM.yyyy", "shortDate"];
    $scope.format  = $scope.theme.getDateFormat() || 'dd/MM/yyyy';
    $scope.esb = esb;
    $scope.detailsInfo = "ok";
    $scope.fecha = new Date;
    $scope.init = false;
    $scope.messages = [];
    $scope.band = undefined;
    $scope.newMessage = null;
    $scope.optionsBorrower = null;
    $scope.uploaderArray = [];
    $scope.uploaderArray2 = [];
    $scope.answerToShow = [];
    $scope.uploader = [];
    $scope.repliedBy = repliedBy;
    $scope.replyDate = $filter('date')(new Date(replyDate), $scope.format);
    $scope.body = notification.body;
    $scope.readOnlyForm = $scope.body.constraints.readOnly;
    var alternateChannelId = null;
    var alternateChannel = null;
    $scope.chat = false;
    $scope.docsImage = {}
    $scope.targetField = {}
    $scope.txtFileNames = {}
    $scope.txtImages = {}
    $scope.txtImagesSkip = {}
    $scope.txtTitleImages = {};
    $window.sessionStorage.removeItem("addrressStateCode");
    let source;
    /*****AUDIO */
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = audioCtx.createAnalyser();
    analyser.minDecibels = -90;
    analyser.maxDecibels = -10;
    analyser.smoothingTimeConstant = 0.85;

    const distortion = audioCtx.createWaveShaper();
    const gainNode = audioCtx.createGain();
    const biquadFilter = audioCtx.createBiquadFilter();
    const convolver = audioCtx.createConvolver();
    const echoDelay = createEchoDelayEffect(audioCtx);
   

    $scope.iconRecord = "recordon";
    $scope.textRecord = "Grabar";
    $scope.iconMic = "microphoneoff";
    $scope.textRecordColor = "#c72026";
    $scope.iconPlay = "playonn";
    $scope.iconDelete = "trash";
    $scope.isPlayingAudio = false;
    $scope.isReadyToPlay = false;
    $scope.isRecording = false;
    $scope.clock = "00:00";
    $scope.tickInterval = 1000;
    $scope.ti = 0;
    $scope.audioSrc;
    var mytimeout;
    let shouldStop;
    let stopped;
    let mediaRecorder;
    let audio;
    var lastBlob;

    function stopRecord() {
        $scope.isRecording = false;
        $scope.iconRecord = "recordon";
        $scope.textRecord = "Grabar";
        $scope.textRecordColor = "#c72026";
        $scope.existAudio = true;
        $timeout.cancel(mytimeout);
        shouldStop = true;
        $scope.isPlayingAudio = false; 
    }

    $scope.stopPlayPublic = function () {
        $scope.isPlayingAudio = false;
        $scope.iconPlay = "playoff";
    } 

    $scope.reload = function () {
       $route.reload();
    }

    function pausePlay() {
        $scope.isPlayingAudio = false;
        $scope.iconPlay = "playoff";
    }

    function stopPlay() {
        $scope.isPlayingAudio = false;
        $scope.iconPlay = "playoff";
    }

    $scope.startRecord = function (index) {
        $window.sessionStorage.setItem("modalAudioCapture", index);
        if ($scope.isRecording) {
            stopRecord();
        }
        else {
            navigator.mediaDevices.getUserMedia({ "audio": true })
                .then(handleSuccess)
                .catch(errorCallback);
        }

    }

    let errorCallback = (err) => {

        var message = "";
        if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
            message = "El micrófono es requerido para utilizar esta funcionalidad";
        } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
            message = "Debe habilitar los permisos de micrófono";
        } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
            message = "Ha ocurrido un error al activar el micrófono";
        } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
            //permission denied in browser 
            message = "Debe habilitar los permisos de micrófono";

        } else if (err.name == "TypeError" || err.name == "TypeError") {
            message = "Ha ocurrido un error al activar el micrófono";
        } else {
            message = "Debe habilitar los permisos de micrófono";
        }
        alert(message);
        console.log('navigator.getUserMedia error: ', err);
    };

    function createEchoDelayEffect(audioContext) {
        const delay = audioContext.createDelay(1);
        const dryNode = audioContext.createGain();
        const wetNode = audioContext.createGain();
        const mixer = audioContext.createGain();
        const filter = audioContext.createBiquadFilter();

        delay.delayTime.value = 0.75;
        dryNode.gain.value = 1;
        wetNode.gain.value = 0;
        filter.frequency.value = 1100;
        filter.type = "highpass";

        return {
            apply: function () {
                wetNode.gain.setValueAtTime(0.75, audioContext.currentTime);
            },
            discard: function () {
                wetNode.gain.setValueAtTime(0, audioContext.currentTime);
            },
            isApplied: function () {
                return wetNode.gain.value > 0;
            },
            placeBetween: function (inputNode, outputNode) {
                inputNode.connect(delay);
                delay.connect(wetNode);
                wetNode.connect(filter);
                filter.connect(delay);

                inputNode.connect(dryNode);
                dryNode.connect(mixer);
                wetNode.connect(mixer);
                mixer.connect(outputNode);
            },
        };
    }
 

    function visualize() {
        const canvas = document.querySelector("#canvasAudio");
        const canvasCtx = canvas.getContext("2d");
        WIDTH = canvas.width;
        HEIGHT = canvas.height;
  
        analyser.fftSize = 256;
        const bufferLengthAlt = analyser.frequencyBinCount;
       
        const dataArrayAlt = new Uint8Array(bufferLengthAlt);

        canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);

        const drawAlt = function () { 

            analyser.getByteFrequencyData(dataArrayAlt);

            canvasCtx.fillStyle = "#ebebec";
            canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

            const barWidth = (WIDTH / bufferLengthAlt);
            let barHeight;
            let x = 0;

            for (let i = 0; i < bufferLengthAlt; i++) {
                barHeight = dataArrayAlt[i];
                canvasCtx.fillStyle = "rgb(0,0,0)";
                canvasCtx.fillRect(
                    x,
                    HEIGHT / 2,
                    barWidth,
                    -barHeight / 2
                );

                x += barWidth + 10;
            }
        };

        drawAlt();

    }
    let fileReader = new FileReader();
    let arrayBuffer;
    let sourceNode;
    let handleSuccess = function (stream) {

        source = audioCtx.createMediaStreamSource(stream);
 
        analyser.connect(audioCtx.destination);

       

        let options;
        let recordedChunks = [];
        shouldStop = false;
        stopped = false;
        mediaRecorder = new MediaRecorder(stream);
        if (audio != null) {
            audio.pause();
            audio.currentTime = 0;
        }
        $scope.isRecording = true;
        $scope.iconRecord = "stopon";
        $scope.iconMic = "microphoneon";
        $scope.textRecord = "Detener";
        $scope.textRecordColor = "#246bb3";

        $scope.ti = 0;

        mediaRecorder.start(10);
        mytimeout = $timeout(tick, $scope.tickInterval);
        mediaRecorder.addEventListener('dataavailable', function (e) {
            visualize();
            if (e.data.size > 0) {
                recordedChunks.push(e.data);
            }

            if (shouldStop === true && stopped === false) {
                mediaRecorder.stop();
                stream.getAudioTracks().forEach(function (track) {
                    track.stop();
                });
                stopped = true;
            }
        });

        mediaRecorder.addEventListener('start', function (e) {
            console.log('Started, state = ' + mediaRecorder.state);
        });

        mediaRecorder.addEventListener('stop', function () {
            audio = document.getElementById('audioCapturePreview');
            lastBlob = new Blob(recordedChunks, { type: 'audio/aac' });
             
            sendAudio()

        });
        
        fileReader.onloadend = () => {
            arrayBuffer = fileReader.result;
            audioCtx.decodeAudioData(arrayBuffer).then((decodedBuffer) => {
                sourceNode = new AudioBufferSourceNode(audioCtx, {
                        buffer: decodedBuffer,
                        loop: false,
                    });
                const javascriptNode = audioCtx.createScriptProcessor(
                    1024,
                    1,
                    1
                    );
                // Connect the nodes together
                sourceNode.connect(audioCtx.destination);
                sourceNode.connect(analyser);
                analyser.connect(javascriptNode);
                javascriptNode.connect(audioCtx.destination);
               
                javascriptNode.onaudioprocess = () => {
                    visualize();
                }
                $scope.ti = 0;
                sourceNode.start(0)
                
                sourceNode.addEventListener("ended", (event) => {
                    $timeout.cancel(mytimeout);
                    shouldStop = true;
                    $scope.isPlayingAudio = false;
                   
                    $scope.ti = 0;
                    $scope.isPlaying = false
                 })
                $scope.isPlaying = true
                mytimeout = $timeout(tick, $scope.tickInterval);
            })
        }
        
        
        mediaRecorder.addEventListener('warning', function (e) {
            log('Warning: ' + e);
        });

        mediaRecorder.addEventListener('error', evt => {
            reject(evt);
        });
    };

    $scope.startPlayAudio = function() {
        if(!$scope.isPlaying) {

        }
        fileReader.readAsArrayBuffer(lastBlob);         
    } 

    $scope.pausePlayAudio = function() {
        if (audioCtx.state === "running") {
            audioCtx.suspend().then(() => {
                $scope.iconPlay = "playonn"
            });
          } else if (audioCtx.state === "suspended") {
            audioCtx.resume().then(() => {
              $scope.iconPlay = "pause"
            });
          } 
    } 

    
    
    let sendAudio = function(){         
          $scope.generatingSignature = "ok";
            var blobUrl = audio.src;
            var index = $window.sessionStorage.getItem("modalAudioCapture");  
            var type = $scope.formBody[index].metadata.constraints.nameToSave
            const payload = new FormData();
            payload.append('type', type);
            payload.append('fileExtension', 'aac');
            payload.append('latitude', "1");
            payload.append('longitude', "1");
            payload.append('file', lastBlob, 'voice.aac');
            var file = URL.createObjectURL(lastBlob);
            services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
                $scope.generatingSignature = undefined;
                if(response.data.url){   
                  var i = $window.sessionStorage.getItem("modalAudioCapture");      
                  $scope.formBody[i].metadata.defaultValue = response.data.url
                  $scope.isReadyToPlay = true 
                }
            }); 
    }

    var tick = function () {
        if(audioCtx.state === "running") {
            $scope.ti++;
            var hr = (Math.floor($scope.ti / 3600) < 10) ? ("0" + Math.floor($scope.ti / 3600)) : (Math.floor($scope.ti / 3600));
            var min = (Math.floor($scope.ti / 60) < 10) ? ("0" + Math.floor($scope.ti / 60)) : (Math.floor($scope.ti / 60));
            var sec = $scope.ti % 60 < 10 ? ("0" + $scope.ti % 60) : ($scope.ti % 60);
            $scope.clock = min + ":" + sec;
            mytimeout = $timeout(tick, $scope.tickInterval);
        }
    }

    $scope.startPlay = function () {
        if ($scope.isPlayingAudio) {
            pausePlay();
        }
        else {
            $scope.isPlayingAudio = true;
            $scope.iconPlay = "pauseon";
        }

    }

    /**** AUDIO */

    if ($location.search().alternateChannelId != null && $location.search().alternateChannelId != 'undefined' && $location.search().alternateChannel != null && $location.search().alternateChannelId != 'undefined') {
        alternateChannelId = $location.search().alternateChannelId;
        alternateChannel = $location.search().alternateChannel;
        console.log("Soy de un canal alternativo.  alternateChannelId: " + alternateChannelId + " - alternateChannel: " + alternateChannel);
    }


    for (var i = 0; i < $scope.formBody.length; i++) {
        if ($scope.formBody[i].metadata.defaultValue === undefined)
            $scope.formBody[i].metadata.defaultValue = '';
    }
    templates.template();
    $scope.page = 1;
    $scope.prev = function () {
        if ($scope.page > 0)
            $scope.page--;
    }
    $scope.next = function (tableConfig) {
        if (tableConfig.currentPage < (tableConfig.table.length - 1)) {
            tableConfig.currentPage++;
            tableConfig.subtable = $scope.getTableConfig(tableConfig);
        }
    }
    $scope.getTableConfig = function (tableConfig) {
        var currentPage = tableConfig.currentPage;
        var table = tableConfig.table;
        var rows = new Array();
        for (var rs of table) {
            var row = new Array();
            for (var item of rs) {
                if (item.page === currentPage || item.type === "header") {
                    row.push(item);
                }
            }
            rows.push(row);
        }
        console.log(rows);
        return rows;
    }
    for (bodyItem of $scope.formBody) {
        if (bodyItem.metadata.constraints.type === 'Select' && bodyItem.metadata.instruction.multiselect === 'true') {
            var options = bodyItem.metadata.constraints.options;
            for (op of options) {
                if (bodyItem.metadata.defaultValue == op.id) {
                    bodyItem.metadata.defaultText = op.value
                }
            }

        }

        if (bodyItem.metadata.constraints.type === 'Document') {
            if (bodyItem.metadata.defaultValue) {
                var value = JSON.parse(bodyItem.metadata.defaultValue)
                var data = bodyItem.metadata.constraints.data[0]
                $scope.txtImages[bodyItem.targetField] = {};
                $scope.txtTitleImages[bodyItem.targetField] = {};
                $scope.txtFileNames[bodyItem.targetField] = {};
                $scope.txtFileNames[bodyItem.targetField][data.id] = value.fileName
                $scope.txtImages[bodyItem.targetField][data.id] = true
                $scope.txtTitleImages[bodyItem.targetField][data.id] = true
                $scope.docsImage[bodyItem.targetField] = true;
            }
        }


        if (bodyItem.metadata && bodyItem.metadata.constraints && bodyItem.metadata.constraints.tableConfig) {
            bodyItem.metadata.constraints.tableConfig["pages"] = 1;
            bodyItem.metadata.constraints.tableConfig.style = "form";
            bodyItem.metadata.constraints.tableConfig.showVertical = false;
            if (bodyItem.metadata.constraints.orientation === "vertical") {
                bodyItem.metadata.constraints.tableConfig.showVertical = true;
            }

            var header = bodyItem.metadata.constraints.tableConfig.header.split(",");
            var row = new Array()
            var table = new Array()
            var body = bodyItem.metadata.constraints.tableConfig.body;
            var pages = bodyItem.metadata.constraints.tableConfig.pages
            if (body.length > 0) {
                bodyItem.metadata.constraints.tableConfig["totalPages"] = Math.floor((body.length - 1) / pages);
                var it = body[0];
                var keys = Object.keys(it);
                for (var i = 0; i < keys.length; i++) {
                    var row = new Array()
                    key = keys[i];
                    row.push({
                        value: header[i],
                        type: "header",
                        style: "background-color: #51596A !important; color: #f2f2f2; font-weight: bold;"
                    });
                    var index = 0;
                    for (var item of body) {
                        itk = item[key]
                        if (itk.type) {
                            itk["page"] = Math.floor(index / pages);
                        } else {
                            itk = {
                                page: Math.floor(index / pages),
                                value: itk,
                                type: "notype"
                            }
                        }
                        row.push(itk);
                        index++;
                    }
                    table.push(row);
                }
                bodyItem.metadata.constraints.tableConfig["table"] = table;
                bodyItem.metadata.constraints.tableConfig["currentPage"] = 0;
                bodyItem.metadata.constraints.tableConfig["subtable"] = $scope.getTableConfig(bodyItem.metadata.constraints.tableConfig);
                bodyItem.metadata.constraints.tableConfig["showVertical"] = false;

            }
        }
    }

    $scope.convertToNumber = function (index) {
        $scope.formBody[index].metadata.defaultValue = Number($scope.formBody[index].metadata.defaultValue);
    };

    if (alternateChannelId == null && alternateChannel == null) {
        if ($localStorage.msg)
            $scope.messages = $localStorage.msg;
    }
    else {
        var channel //variable localStorage
        channel = $localStorage.channel.find(data => data.alternateChannel === $routeParams.alternateChannel)
        if (channel.body) {
            $scope.messages = channel.body;
        }

    }


    $scope.demo = {
        showTooltip: false,
        tipDirection: "right"
    };
    $scope.isJson = function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    $scope.showInfo = function (expandible) {
        if (expandible.isExpandable === "true") {
            expandible.isExpandable = undefined;
            $scope.detailsInfo = undefined;
        } else {
            $scope.detailsInfo = "ok";
            expandible.isExpandable = "true";
        }
    };
    $scope.actionCancel = function () {
        location.href = "#/" + $scope.viewTemplate;
    };

    $scope.showConfirm = function (ev, idData) {
        var confirm = $mdDialog.confirm().title("Confirmar operación").textContent("Desea descartar esta notificación?").ariaLabel("Lucky day").targetEvent(ev).ok("Si").cancel("No");
        $mdDialog.show(confirm).then(function () {
            $scope.progress = "ok";
            $scope.declineNotifications(idData);
        }, function () { });
    };


    $scope.buildConfirmationMessage = function () {

        var confirmationData = new Object();
        confirmationData.confirmationLabel = "Estás seguro (a) de continuar?";
        confirmationData.showConfirmationText = true;
        if (notification.metadata && notification.metadata.instruction) {
            if (notification.metadata.instruction.confirmationLabel)
                confirmationData.confirmationLabel = notification.metadata.instruction.confirmationLabel;
            if (notification.metadata.instruction.responseDisplay) {
                if (notification.metadata.instruction.responseDisplay.confirmationDisabled)
                    confirmationData.showConfirmationText = false;
            }
        }
        confirmationData.type = "form";
        var responseform = [];
        $scope.textToShowInChat = "";
        $scope.messageInblock = "";
        $scope.messageConfirmation = "";
        var contador = 1;
        for (var i = 0; i < $scope.formBody.length; i++) {
            let isLabel = $scope.formBody[i].targetField === 'INFO' && ($scope.formBody[i].metadata.defaultValue == undefined || $scope.formBody[i].metadata.defaultValue == null || $scope.formBody[i].metadata.defaultValue === 'INFO');
            let isHidden = $scope.formBody[i].metadata.visibility && $scope.formBody[i].metadata.visibility === 'GONE';
            if (isLabel || isHidden) {
                continue;
            }
            var obj = new Object();
            obj.label = $scope.formBody[i].label || "Data";
            $scope.textToShowInChat = $scope.textToShowInChat + obj.label + " ";

            if ($scope.formBody[i].metadata.constraints && $scope.formBody[i].metadata.constraints.type === 'Select') {
                if ($scope.formBody[i].metadata.instruction.multiselect === 'true') {
                    obj.value = $scope.formBody[i].metadata.defaultText;
                } else {
                    for (var j = 0; j < $scope.formBody[i].metadata.constraints.options.length; j++) {
                        if ($scope.formBody[i].metadata.constraints.options[j].id === $scope.formBody[i].metadata.defaultValue) {
                            obj.value = $scope.formBody[i].metadata.constraints.options[j].value;
                            break;
                        }
                    }
                }
            } else if ($scope.formBody[i].metadata.constraints.type === 'Date') {
                try {
                    obj.value = new Date($scope.formBody[i].metadata.defaultValue).toLocaleDateString();

                } catch (e) { }

            } else if ($scope.formBody[i].metadata.constraints && $scope.formBody[i].metadata.constraints.type === 'ExternalDataQuery') {
                obj.value = $scope.formBody[i].metadata.defaultText;
            } else
                obj.value = $scope.formBody[i].metadata.defaultValue;

            if ($scope.formBody[i].metadata.constraints.type.toUpperCase() === 'DOCUMENT') {
                var valArray = "";
                try {
                    valArray = JSON.parse($scope.formBody[i].metadata.defaultValue)

                } catch (e) {

                }
                if (valArray !== '') {
                    var valShow = "<br><b>Respuestas:</b> <br>";
                    var valArraySend = new Array()
                    for (const item of valArray) {
                        valShow = valShow + (item["title"] + " <br> " + item["filename"]) + " <br>  <br> ";
                        delete item["filename"];
                        delete item["title"];
                        valArraySend.push(item)
                    }
                    obj.value = JSON.stringify(valArraySend)
                    $scope.textToShowInChat = $scope.textToShowInChat + valShow;
                    $scope.messageConfirmation = $scope.messageConfirmation + "<p><strong>" + obj.label.replace(":", "") + ": </strong>" + valShow + "</p>"
                    $scope.messageInblock = $scope.messageInblock + "<p><strong>" + obj.label.replace(":", "") + ": </strong>" + valShow + "</p>"
                    obj.isDocument = true;
                    obj.textContent = valShow;
                }
                contador++;
            } else {
                const parser = new DOMParser();
                const text = parser.parseFromString(obj.value, "text/html");
                if (text.body.firstChild)
                    obj.value = text.body.firstChild.textContent;
                else if (text.head.firstChild)
                    obj.value = $sanitize(obj.value)
                $scope.textToShowInChat = $scope.textToShowInChat + ': ' + obj.value + "<br>";
                if ($scope.formBody[i].metadata.constraints.type.toUpperCase() === 'IMAGE' || $scope.formBody[i].metadata.constraints.type.toUpperCase() === 'CAMERA_VERIFICATION') {
                    try {
                        var objImage = JSON.parse(obj.value);
                        if (objImage != null) {
                            $scope.messageConfirmation = $scope.messageConfirmation + "<p><strong>" + obj.label.replace(":", "") + ": </strong>" + "<a target=\"_blank\" href='" + objImage["url"] + "'>Ver imagen</a>" + "</p>"
                            $scope.messageInblock = $scope.messageInblock + "<p style='color: #666699;'><strong>" + obj.label.replace(":", "") + ": </strong></p><p style='margin: 0; '>" + obj.value + "</p><hr>"
                        }

                    } catch (e) {
                        console.error(e);
                    }

                }
                else {
                    $scope.messageConfirmation = $scope.messageConfirmation + "<p><strong>" + obj.label.replace(":", "") + ": </strong>" + obj.value + "</p>"
                    $scope.messageInblock = $scope.messageInblock + "<p style='color: #666699;'><strong>" + obj.label.replace(":", "") + ": </strong></p><p style='margin: 0; '>" + obj.value + "</p><hr>"
                }
                obj.isDocument = false;
                contador++;
            }

            responseform.push(obj);
        }
        confirmationData.response = responseform;
        $scope.textToShowInChat = $scope.messageConfirmation;
        var jsonString = JSON.stringify(confirmationData);
        return jsonString;
    };


    $scope.showConfirmation = function (ev) {
        var dataConfirmation = $scope.buildConfirmationMessage();
        if (dataConfirmation)
            $window.sessionStorage.setItem("confirmDialog", dataConfirmation);
        $mdDialog.show({
            controller: 'confirmationCntrl',
            templateUrl: './views/dashboard/confirmation.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {
            $scope.pendingSend();
        }, function () { });
    };


    $scope.showAlert = function (msg, title) {
        $scope.progress = undefined;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"));
    };



    $scope.datePicker = {
        opened: false
    };

    $scope.open = function (popup) {
        popup.opened = true;
    };

    $scope.toDate = function (dateStr) {
        const [day, month, year] = dateStr.split("-");
        return new Date(year, month - 1, day)
    };
    $scope.actionSend = function (formBody) {
               
        var objxmpp = {};
        var count = 0;
        var keyArrayUpload = Object.keys($scope.uploader);
        $scope.fileUploadObj = $scope.uploader[parseInt(keyArrayUpload[0])];

        for (i = 0; i < formBody.length; i++) {
            if (formBody[i].metadata.defaultValue !== undefined && formBody[i].metadata.defaultValue !== null) {
                objxmpp[formBody[i].targetField] = formBody[i].metadata.defaultValue;
            }
            var metadataObj = formBody[i].metadata
            if (formBody[i].metadata.instruction != null && formBody[i].metadata.instruction.gps != null) {
                if (formBody[i].metadata.instruction.gpsResult == null) {
                    if ($scope.gpsDataPosition != null) {
                        objxmpp[metadataObj.instruction.gps.targets.permissionGranted] = true;
                        objxmpp[metadataObj.instruction.gps.targets.latitude] = $scope.gpsDataPosition.coords.latitude;
                        objxmpp[metadataObj.instruction.gps.targets.longitude] = $scope.gpsDataPosition.coords.longitude;
                        objxmpp[metadataObj.instruction.gps.targets.address] = gpsData[notification.metadata.instruction.gps.targets.address]
                        objxmpp[metadataObj.instruction.gps.targets.city] = gpsData[notification.metadata.instruction.gps.targets.city]
                    }
                }
                else {

                    if ($scope.gpsDataPosition != null) {
                        objxmpp[metadataObj.instruction.gps.targets.permissionGranted] = true;
                        objxmpp[metadataObj.instruction.gps.targets.latitude] = $scope.gpsDataPosition.coords.latitude;
                        objxmpp[metadataObj.instruction.gps.targets.longitude] = $scope.gpsDataPosition.coords.longitude;
                        objxmpp[metadataObj.instruction.gps.targets.address] = gpsData[notification.metadata.instruction.gps.targets.address]
                        objxmpp[metadataObj.instruction.gps.targets.city] = gpsData[notification.metadata.instruction.gps.targets.city]
                    }

                    const gpsMapData = new Map(Object.entries(formBody[i].metadata.instruction.gpsResult));
                    for (const key of gpsMapData.keys()) {
                        objxmpp[key] = gpsMapData.get(key)
                    }
                }

            }

            if (formBody[i].metadata.constraints != null && formBody[i].metadata.constraints.fileName !== undefined && formBody[i].metadata.constraints.fileName !== null) {
                $scope.targetField = formBody[i].targetField;
                $scope.fileUploaded = false;
                $scope.containsFile = true;
                if ($scope.fileUploadObj && $scope.fileUploadObj.getNotUploadedItems().length) {
                    $scope.fileUploadObj.uploadAll();
                    $scope.fileUploadObj.onCompleteItem = function (item, response) {
                        $scope.progress = false;
                        if (response.data === undefined) {
                            $mdToast.show($mdToast.simple().textContent("Error al subir el archivo").position("top").action("Ok").theme("error-toast").hideDelay(4000));
                            $scope.fileUploadObj.clearQueue();
                            objxmpp["invalidFile"] = true;
                            $scope.fileUploaded = true;
                        } else {
                            objxmpp[$scope.targetField] = esb + "/security" + response.data.url;
                            $scope.fileUploaded = true;
                        }
                    }
                } else {
                    objxmpp[$scope.targetField] = $scope.targetField;
                    $scope.containsFile = false;
                }
            }
        }
        return objxmpp;
    };

    $scope.actionSendMultiple = function (formBody, id) {
        $scope.progress = "ok";
        var arrayXmpp = [];
        var objxmpp = {};
        var count = 0;
        for (i = 0; i < formBody.length; i++) {
            if (formBody[i].metadata.defaultValue !== undefined && formBody[i].metadata.defaultValue !== null)
                objxmpp[formBody[i].targetField] = formBody[i].metadata.defaultValue;

            if (formBody[i].metadata.constraints != null && formBody[i].metadata.constraints.fileName !== undefined) {
                $scope.targetField = formBody[i].targetField;
                arrayXmpp.push($scope.targetField);
                $scope.fileUploaded = false;
                $scope.containsFile = true;
            }

            if (formBody[i].metadata.instruction != null && formBody[i].metadata.instruction.gps != null) {

                if (formBody[i].metadata.instruction.gpsResult == null) {
                    if ($scope.gpsDataPosition != null) {
                        objxmpp[metadataObj.instruction.gps.targets.permissionGranted] = true;
                        objxmpp[metadataObj.instruction.gps.targets.latitude] = $scope.gpsDataPosition.coords.latitude;
                        objxmpp[metadataObj.instruction.gps.targets.address] = gpsData[metadataObj.instruction.gps.targets.address]
                        objxmpp[metadataObj.instruction.gps.targets.city] = gpsData[metadataObj.instruction.gps.targets.city]

                    }
                }
                else {

                    const gpsMapData = new Map(Object.entries(formBody[i].metadata.instruction.gpsResult));
                    for (const key of gpsMapData.keys()) {
                        objxmpp[key] = gpsMapData.get(key)
                    }
                }

            }
        }

        for (var i = 0; i < $scope.uploader.length; i++) {
            if ($scope.uploader[i] !== undefined && $scope.uploader[i].getNotUploadedItems().length) {
                $scope.uploader[i].uploadAll();
                $scope.uploader[i].onCompleteItem = function (item, response) {
                    if (response.data === undefined) {
                        $scope.progress = false;
                        $mdToast.show($mdToast.simple().textContent("Error al subir el archivo").position("top").action("Ok").theme("error-toast").hideDelay(4000));
                        $scope.uploader[i].clearQueue();
                        objxmpp["invalidFile"] = true;
                        $scope.fileUploaded = true;
                    } else {
                        for (var i = 0; i < arrayXmpp.length; i++) {
                            var array = arrayXmpp[i].split(".");
                            if (response.data.type.toLowerCase() === array[0].toLowerCase()) {
                                objxmpp[arrayXmpp[i]] = esb + "/security" + response.data.url;
                                $scope.fileUploaded = true;
                                count++;
                            }
                        }
                    }
                    if (count == arrayXmpp.length) {
                        if ($scope.containsFile) {
                            $scope.waitSendFilledForm(objxmpp, id);
                        } else {
                            $scope.sendFilledForm(objxmpp, id, null);
                        }
                    }
                }
            }
        }
    };

    $scope.setConstraints = function (index, minDate, maxDate) {
        var minD = null;
        var maxD = null;

        if (minDate)
            minD = new Date(minDate);
        if (maxDate)
            maxD = new Date(maxDate);

        $scope.formBody[index].metadata.dateOptions = {
            formatYear: "yy",
            maxDate: maxD,
            minDate: minD,
            startingDay: 1,
            showWeeks: false
        }
    };

    $scope.renderHtml = function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };

    $scope.evalSelectDefault = function (index, value, options) {
        var exists = false;
        for (i = 0; i < options.length; i++) {
            if (options[i].id === value) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            $scope.formBody[index].metadata.defaultValue = "";
        }
    };

    $scope.formCalendar = function (index, date) {
        date = date.toString();
        if (date.includes("GMT")) {
            var format = "dd-MM-yyyy";
            date = $filter("date")(new Date(date), format);
            date = $scope.toDate(date);
        } else date = $scope.toDate(date);
        $scope.formBody[index].metadata.defaultValue = Date.parse(date);
    }

    $scope.defaultDate = function (index, date, maxDate) {
        var today = new Date();
        if (date && date.length == 0) {
            if (maxDate && maxDate < today)
                $scope.formCalendar(index, new Date(maxDate));
            else if (maxDate == null)
                $scope.formCalendar(index, today);
        }
        else if (date && date.length > 0) {
            var n = Number(date);
            date = new Date(n);
            $scope.formCalendar(index, date);
        }
    }

    $scope.setDate = function (index, date) {
        if (date !== null && date !== undefined && data !== "") {
            $scope.formCalendar(index, date);
        }
    };

    $scope.sendMsg = function (ev, msg, id) {

        if (notification.metadata && notification.metadata.instruction && notification.metadata.instruction.confirmation) {
            $scope.showConfirmation();
            $scope.pendingSend = function () {
                $scope.uploadersFiles = $scope.uploader.filter(Boolean);
                if ($scope.uploadersFiles.length > 1) {

                    var message = $scope.actionSendMultiple(msg, id);
                    // console.log(message); return;
                }
                else {
                    var message = $scope.actionSend(msg, id);
                    //  console.log(message); return;
                    message = JSON.stringify(message);
                    if ($scope.containsFile) {
                        $scope.progress = "ok";
                        $scope.waitSendFilledForm(message, id);
                    } else {
                        var formatedMessageInBlock = null;
                        if (notification.metadata.instruction.responseDisplay) {
                            if (notification.metadata.instruction.responseDisplay.collapse) {
                                formatedMessageInBlock = $scope.messageInblock;
                                $scope.textToShowInChat = "Información registrada"
                            }

                            if (notification.metadata.instruction.responseDisplay.hideDetail) {
                                formatedMessageInBlock = null;
                                $scope.textToShowInChat = "Información registrada"
                            }

                        }
                        $scope.sendFilledForm(message, id, formatedMessageInBlock);
                    }
                }
            }
        } else {
            $scope.uploadersFiles = $scope.uploader.filter(Boolean);
            if ($scope.uploadersFiles.length > 1) {
                var message = $scope.actionSendMultiple(msg, id);
                // console.log(message); return; 
            }
            else {
                var message = $scope.actionSend(msg, id);
                // console.log(message); return;
                message = JSON.stringify(message);
                $scope.buildConfirmationMessage();
                if ($scope.containsFile) {
                    $scope.progress = "ok";
                    $scope.waitSendFilledForm(message, id);
                } else {
                    var formatedMessageInBlock = null;
                    if (notification.metadata && notification.metadata.instruction && notification.metadata.instruction.responseDisplay) {
                        if (notification.metadata.instruction.responseDisplay.collapse) {
                            formatedMessageInBlock = $scope.messageInblock;
                            $scope.textToShowInChat = "Información registrada"
                        }

                        if (notification.metadata.instruction.responseDisplay.hideDetail) {
                            formatedMessageInBlock = null;
                            $scope.textToShowInChat = "Información registrada"
                        }

                    }
                    $scope.sendFilledForm(message, id, formatedMessageInBlock);
                }
            }
        }
    };

    $scope.waitSendFilledForm = function (message, id) {
        var f = function () {
            if ($scope.fileUploaded) {
                if (!message.invalidFile) $scope.sendFilledForm(message, id, null);
            }
            while (!$scope.fileUploaded) {
                setTimeout(f, 100);
                break;
            }
        };
        setTimeout(f, 100);
    };

    $scope.dashboardUrl = "/#/dashboard";
    if ($window.sessionStorage.getItem("viewTemplate") != null && $window.sessionStorage.getItem("viewTemplate") != undefined && $window.sessionStorage.getItem("viewTemplate").includes("channel")) {
        $scope.dashboardUrl = "/#/" + $window.sessionStorage.getItem("viewTemplate");
        //$scope.dashboardUrl = "#dashboard";
    }
    if ($window.sessionStorage.getItem("urlTag") != null) {
        $scope.dashboardUrl = $scope.dashboardUrl + $window.sessionStorage.getItem("urlTag")
    }
    $scope.sendFilledForm = function (message, id, formatedMessageInBlock) {
        //   console.log(message); return;
        $scope.progress = true;
        xmppAuth.Chat.sendMessageInBlock(xmppUser + "@" + xmpp_domain, $scope.textToShowInChat, message, formatedMessageInBlock, "sent", "REPLY", id, alternateChannelId, alternateChannel);
        $timeout(function () {
            $window.sessionStorage.removeItem("dataNotification");
            $window.localStorage.removeItem("metadataObj");
            $location.path("/dashboard");
        }, 400);

    };
    $scope.downloadLink = "";
    $scope.imagePreview = function (url) {
        var modal = document.getElementById("imageModal");
        var modalImg = document.getElementById("zoomedImage");
        modal.style.display = "block";
        modalImg.src = $scope.esb + "/security" + url;
        $scope.downloadLink = $scope.esb + "/security" + url;

        $("#imageLink").click(function (e) {
            e.preventDefault(); //stop the browser from following
            document.getElementById('downloadFrame').src = $scope.downloadLink;
        });
        $scope.zoom = 80;
        $scope.maxWidth = 700;
        $('#zoomedImage').css("width", "80%")
        $('#zoomedImage').css("max-width", "700px");
    };
    $scope.zoom = 80;
    $scope.maxWidth = 700;
    $scope.zoomInModal = function () {
        var modalImg = document.getElementById("zoomedImage");
        $scope.zoom += 5;
        $scope.maxWidth = $scope.maxWidth * 1.05;
        console.log('maxWidth: ' + $scope.maxWidth);
        $('#zoomedImage').css("z-index", "-5000");
        $('#zoomedImage').css("width", $scope.zoom + "%")
        $('#zoomedImage').css("max-width", $scope.maxWidth + "px");

        console.log($('#zoomedImage').css("width"));
    };
    $scope.zoomOutModal = function () {
        var modalImg = document.getElementById("zoomedImage");
        $scope.zoom -= 5;
        $scope.maxWidth = $scope.maxWidth * 0.95;
        console.log('maxWidth: ' + $scope.maxWidth);
        $('#zoomedImage').css("z-index", "-5000");
        $('#zoomedImage').css("width", $scope.zoom + "%")
        $('#zoomedImage').css("max-width", $scope.maxWidth + "px");

        console.log($('#zoomedImage').css("width"));
        console.log($('#zoomedImage').css("width"));
    };
    $scope.closeModal = function () {
        var modal = document.getElementById("imageModal");
        modal.style.display = "none";
    };


    $scope.zoomCaptured = function (url) {
        var modal = document.getElementById("zoomImage");
        var modalImg = document.getElementById("img01");


        modal.style.display = "block";
        modalImg.src = $scope.esb + "/security" + url;
        var span = document.getElementsByClassName("close")[0];
        span.onclick = function () {
            var modal = document.getElementById("zoomImage");
            modal.style.display = "none";
        }

    }

    $scope.$on("msgRecievedBroadcast", function (event, data, type) {
        switch (type) {
            case "ack":
                $scope.safeApply($scope.msgACK(data));
                break;
            default:
                $scope.safeApply($scope.messageReceive(data))
                break;
        }
    });

    $scope.safeApply = function (fn) {
        var phase = this.$root.$$phase;
        if (phase === "$apply" || phase === "$digest") {
            if (fn && typeof fn === "function") {
                fn()
            }
        } else {
            this.$apply(fn)
        }
    };
    $scope.msgACK = function (data) {
        console.log(data);
        const resultado = $scope.messages.find(msg => msg.id === data);
        if (resultado !== undefined) {
            resultado.icon = "checkblue.png";
            resultado.ack = true;
        }
    }

    $scope.messageReceive = function (data) {
        if (data.text) {
            if (data.id) {
                $scope.dataId = data.id;
                $cookieStore.put("id", data.id, {})
            }
            $scope.messages.push(data);

            if (alternateChannel != null && alternateChannelId != null) {
                var channel //variable localStorage
                channel = $localStorage.channel.find(data => data.alternateChannel === $routeParams.alternateChannel)
                channel.msg = $scope.messages;
            }
            else
                $localStorage.msg = $scope.messages

        }
    }

    $scope.compare = function (data) {
        if (data.type !== undefined) {
            var item;
            if (data.type == "date")
                item = $filter('date')(data.value, "MMM-dd-yyyy");
            else if (data.type == "money")
                item = $filter('currency')(data.value, "$")
            return item
        }
    }

    $scope.headerTable = function (data) {
        if (data.header) {
            var array = data.header.split(",");
            return array
        }
    }



    $scope.loadOptions = function (data) {
        return $timeout(function () {
            $scope.optionsBorrower = $scope.optionsBorrower || [{
                id: 1,
                name: 'Iniciar conversación'
            },
            {
                id: 2,
                name: 'Información del cliente'
            },
            ];
        }, 650);
    };



    $(function () {
        $('.fa-minus').click(function () {
            $(this).closest('.chatbox').toggleClass('chatbox-min');
        });
        $('.fa-close').click(function () {
            $(this).closest('.chatbox').hide();
        });
    });

    $scope.typeRegex = function (data) {
        $scope.expReg = new RegExp(data);
    };
    $scope.typeRegexChat = function (data) {
        return new RegExp(data);
    };
    $scope.closeDialog = function () {
        $window.sessionStorage.removeItem("confirmDialog");
        if ($window.sessionStorage.getItem("viewTemplate") != null && $window.sessionStorage.getItem("viewTemplate") != undefined && $window.sessionStorage.getItem("viewTemplate").includes("channel"))
            $location.path("/" + $window.sessionStorage.getItem("viewTemplate"));
        else
            $location.path("/dashboard");
    };

    $scope.listCheckbox = function (ev, metadata, index) {
        $window.localStorage.setItem('metadataObjToForm', JSON.stringify(metadata))
        $window.localStorage.setItem('ismetadaDynamicForm', "true")
        var confirm = $mdDialog.show({
            controller: 'list',
            templateUrl: 'selectListMultiple.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {
            $scope.formBody[index].metadata.defaultValue = answer.id;
            $scope.answerToShow[index] = answer.value;
            $scope.formBody[index].metadata.defaultText = answer.value;
            console.log($scope.answerToShow[index]);

        }, function () {
            $scope.disabledBtn = false;
        });
        if (ev) {
            $scope.typeSelect = 1;
        }
    };

    $scope.modalImageCaptureDialog = function (index, defaultCamera, ev) {
        $window.sessionStorage.setItem("modalimageCapture", index);
        $window.sessionStorage.setItem("defaultCamera", defaultCamera);


        if (notification.metadata.instruction != null && notification.metadata.instruction.gps != null) {
            setPositionOnItemGps(index, $scope.formBody[index].metadata);
        }

        var confirm = $mdDialog.show({
            controller: 'cameraFormCntrl',
            templateUrl: './views/dashboard/capture.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {
            var i = $window.sessionStorage.getItem("modalimageCapture");



            $window.sessionStorage.removeItem("modalimageCapture");
            var imageCapturePreview = document.getElementById('imageCapturePreview');
            imageCapturePreview.src = answer.fileName;
            $scope.formBody[i].metadata.defaultValue = answer.url;
            console.log($scope.formBody[i].metadata.defaultValue)
        }, function () {

        });
    }
    $scope.modalImageCapture = function (ev) {
        cameraPermission(ev, $scope.modalImageCaptureDialog)
    }

    $scope.hasAudio = false;

    function audioPermission(ev, index, nextCall) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then((stream) => {
            nextCall(ev, index)
        },
            e => {
                if (e.message == "Permission denied")
                    $scope.cameraTour(ev, nextCall)
            })
    }

    $scope.modalAudioCaptureDialog = function (ev, index) {
        $window.sessionStorage.setItem("modalAudioCapture", index);

        var confirm = $mdDialog.show({
            controller: 'audioCntrl',
            templateUrl: './views/dashboard/audio.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {
            var i = $window.sessionStorage.getItem("modalAudioCapture");
            $window.sessionStorage.removeItem("modalAudioCapture");
            $scope.hasAudio = true;


            $scope.formBody[i].metadata.defaultValue = answer.url;
            console.log("AUDIO ANSWER: " + answer)
        }, function () {

        });
    }
    $scope.modalAudioCapture = function (index, label, ev) {
        $window.sessionStorage.setItem("modalAudioCaptureLabel", label);
        audioPermission(ev, index, $scope.modalAudioCaptureDialog)
    }

    $scope.getMandatory = function (data) {
        var size = 0;
        for (const item of data) {
            if (item.mandatory === true) {
                size++;
            }
        }
        return size + " archivos obligatorios";
    }
    $scope.cameraTour = function (ev) {
        var confirm = $mdDialog.show({
            locals: {
                isInit: false,
                isAudio: false,
                isVideo: true
            },
            controller: 'cameraTourCntrl',
            templateUrl: './views/dashboard/cameraTour.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            escapeToClose: true,
            targetEvent: ev
        }).then(function (answer) {

        }, function () {

        });
    };


    function cameraPermission(ev, nextCall) {
        if (window.stream) {
            window.stream.getTracks().forEach(track => {
                track.stop();
            });
        }
        navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then((stream) => {
            stream.getTracks().forEach(track => {
                track.stop();
            });
            nextCall(ev)
        },
            e => {
                if (e.message == "Permission denied")
                    $scope.cameraTour(ev, nextCall)
            })
    }
    function audioPermission(ev, index, nextCall) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then((stream) => {
            nextCall(ev, index)
        },
            e => {
                $scope.cameraTour(ev, nextCall)
            })
    }

    $scope.showUploadImageDialog = function (ev) {
        if (notification.metadata.instruction != null && notification.metadata.instruction.gps != null) {
            setPositionOnItemGps(notification.metadata);
        }


        var confirm = $mdDialog.show({
            controller: 'cameraFormCntrl',
            templateUrl: './views/dashboard/cameraForm.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {

            if (!$scope.bodyValues[$scope.targetField]) {
                $scope.bodyValues[$scope.targetField] = {};
            }
            answer["filename"] = currentData[answer.id].fileName
            answer["title"] = $scope.title
            $scope.bodyValues[$scope.targetField][answer.id] = answer;

            if (!$scope.txtFileNames[$scope.targetField]) {
                $scope.txtFileNames[$scope.targetField] = {};
            }
            $scope.txtFileNames[$scope.targetField][answer.id] = currentData[answer.id].fileName;

            if (!$scope.txtImages[$scope.targetField]) {
                $scope.txtImages[$scope.targetField] = {};
            }
            $scope.txtImages[$scope.targetField][answer.id] = true;;

            if (!$scope.txtImagesSkip[$scope.targetField]) {
                $scope.txtImagesSkip[$scope.targetField] = {};
            }
            $scope.txtImagesSkip[$scope.targetField][answer.id] = false;

            if (!$scope.txtTitleImages[$scope.targetField]) {
                $scope.txtTitleImages[$scope.targetField] = {};
            }
            $scope.txtTitleImages[$scope.targetField][answer.id] = true
            var data = $scope.bodyItem[$scope.targetField].metadata.constraints.data;
            var mainImage = true;
            var check = $scope.txtTitleImages[$scope.targetField]
            var values = Object.values(check);
            if (values.length < data.length) { } else {
                for (const item of values) {
                    if (item === false) {
                        mainImage = false;
                    }
                }
                if (mainImage) {
                    $scope.docsImage[$scope.targetField] = true;
                    var values = new Array();
                    var bodyValues = Object.values($scope.bodyValues[$scope.targetField])
                    for (const item of bodyValues) {
                        values.push(item);
                    }
                    $scope.bodyItem[$scope.targetField].metadata.defaultValue = JSON.stringify(values);
                }
            }
        }, function () { });

    };
    $scope.showUploadImage = function (ev) {

        cameraPermission(ev, $scope.showUploadImageDialog)
    }
    $scope.showUploadFile = function (ev) {


        if (notification.metadata.instruction != null && notification.metadata.instruction.gps != null) {
            setPositionOnItemGps(notification.metadata);
        }

        $scope.progress = true;
        $mdDialog.show({
            controller: 'uploadCntrl',
            templateUrl: './views/dashboard/uploadfile.html',
            locals: {
                fileName: ev.currentTarget.files[0].name,
                parentScope: $scope // we sent parentScope to call parentScope.progress = false after loading uploadFile window
            },
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function (answer) {
            if (!$scope.bodyValues[$scope.targetField]) {
                $scope.bodyValues[$scope.targetField] = {};
            }
            answer["filename"] = currentData[answer.id].fileName
            answer["title"] = $scope.title
            $scope.bodyValues[$scope.targetField][answer.id] = answer;

            if (!$scope.txtFileNames[$scope.targetField]) {
                $scope.txtFileNames[$scope.targetField] = {};
            }
            $scope.txtFileNames[$scope.targetField][answer.id] = currentData[answer.id].fileName;

            if (!$scope.txtImages[$scope.targetField]) {
                $scope.txtImages[$scope.targetField] = {};
            }
            $scope.txtImages[$scope.targetField][answer.id] = true;;

            if (!$scope.txtImagesSkip[$scope.targetField]) {
                $scope.txtImagesSkip[$scope.targetField] = {};
            }
            $scope.txtImagesSkip[$scope.targetField][answer.id] = false;



            if (!$scope.txtTitleImages[$scope.targetField]) {
                $scope.txtTitleImages[$scope.targetField] = {};
            }
            $scope.txtTitleImages[$scope.targetField][answer.id] = true
            var data = $scope.bodyItem[$scope.targetField].metadata.constraints.data;
            var mainImage = true;
            var check = $scope.txtTitleImages[$scope.targetField]
            var values = Object.values(check);
            if (values.length < data.length) { } else {
                for (const item of values) {
                    if (item === false) {
                        mainImage = false;
                    }
                }
                if (mainImage) {
                    $scope.docsImage[$scope.targetField] = true;
                    var values = new Array();
                    var bodyValues = Object.values($scope.bodyValues[$scope.targetField])
                    for (const item of bodyValues) {
                        values.push(item);
                    }
                    $scope.bodyItem[$scope.targetField].metadata.defaultValue = JSON.stringify(values);
                }
            }

        }, function () { });

    };


    var currentData = {}
    $scope.bodyItem = {};
    $scope.bodyValues = {};
    $scope.initItem = function (item) {
        $scope.bodyItem[item.targetField] = item;
        if (item.metadata.defaultValue){
            let answer = JSON.parse(item.metadata.defaultValue);
            answer = answer.length === 1 ? answer[0] : answer;
            if (!$scope.bodyValues[item.targetField]) {
                $scope.bodyValues[item.targetField] = {};
            }
            item["filename"] = answer.value;
            answer["filename"] = answer.value;
            item["title"] = answer.title;
            $scope.bodyValues[item.targetField][answer.id] = answer;

            if (!$scope.txtFileNames[item.targetField]) {
                $scope.txtFileNames[item.targetField] = {};
            }
            $scope.txtFileNames[item.targetField][answer.id] = item.filename;

            if (!$scope.txtImages[item.targetField]) {
                $scope.txtImages[item.targetField] = {};
            }
            $scope.txtImages[item.targetField][answer.id] = true;

            if (!$scope.txtImagesSkip[item.targetField]) {
                $scope.txtImagesSkip[item.targetField] = {};
            }
            $scope.txtImagesSkip[item.targetField][answer.id] = false;

            if (!$scope.txtTitleImages[item.targetField]) {
                $scope.txtTitleImages[item.targetField] = {};
            }
            $scope.txtTitleImages[item.targetField][answer.id] = true
            var data = $scope.bodyItem[item.targetField].metadata.constraints.data;
            var mainImage = true;
            var check = $scope.txtTitleImages[item.targetField]
            var values = Object.values(check);
            if (values.length < data.length) { } else {
                for (const item of values) {
                    if (item === false) {
                        mainImage = false;
                    }
                }
                if (mainImage) {
                    $scope.docsImage[item.targetField] = true;
                    var values = new Array();
                    var bodyValues = Object.values($scope.bodyValues[item.targetField])
                    for (const item of bodyValues) {
                        values.push(item);
                    }
                    $scope.bodyItem[item.targetField].metadata.defaultValue = JSON.stringify(values);
                }
            }
        }
    }
    $scope.uploadFiles = function (ev, data, bodyItem) {
        $scope.formBodyItem = bodyItem
        if (!$scope.readOnlyForm) {
            try {
                if (ev.currentTarget.files[0].$error === "maxSize") {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Advertencia')
                            .textContent('El archivo supera los 5MB permitidos')
                            .ariaLabel('Alert Dialog Demo')
                            .ok('Ok')
                            .targetEvent(ev)
                    );
                } else {
                    currentData[data.id] = data;
                    currentData[data.id].fileName = ev.currentTarget.files[0].name;
                    $scope.targetField = bodyItem.targetField;
                    $scope.title = data.title;
                    sharedService.setShared(ev.currentTarget.files[0]);
                    sharedService.setData(data);
                    $scope.showUploadFile(ev);
                }
            }
            catch (err) {
                //console.log(err);
            }
        }
    }
    $scope.uploadImge = function (ev, data, bodyItem) {
        $scope.formBodyItem = bodyItem
        if (!$scope.readOnlyForm) {
            currentData[data.id] = data;
            currentData[data.id].fileName = "image" + data.id + ".png";
            $scope.targetField = bodyItem.targetField;
            $scope.title = data.title;
            sharedService.setData(data);
            $scope.showUploadImage();
        }

    }

    $scope.delete = function (data, bodyItem) {

        delete $scope.txtFileNames[bodyItem.targetField][data.id];
        delete $scope.txtImages[bodyItem.targetField][data.id];
        $scope.txtFileNames[data.id] = "";
        $scope.txtImages[data.id] = false;
        $scope.txtImagesSkip[data.id] = false;
        $scope.txtTitleImages[bodyItem.targetField][data.id] = false;
        $scope.targetField[data.id] = bodyItem.targetField;
        $scope.docsImage[bodyItem.targetField] = false;
    }

    function DialogController($scope, $mdDialog, items) {
        $scope.items = items;
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.answer = function (data) {
            var answer = {
                value: null,
                extension: null,
                id: "",
                skipId: data.value,
                description: data.description
            }
            $mdDialog.hide(answer);
        };
    }
    $scope.dialogReasons = function (data, bodyItem) {
        $scope.dataReasons = data;
        currentData[data.id] = data;
        $scope.targetField = bodyItem.targetField;
        $scope.title = data.title;
        sharedService.setData(data);
        $mdDialog.show({
            controller: DialogController,
            locals: {
                items: data.skipReasons
            },
            templateUrl: '../views/pages/reasons.html',
            parent: angular.element(document.body)
        })
            .then(function (answer) {
                if (answer) {
                    answer.id = $scope.dataReasons.id;
                    console.log(answer)
                    if (!$scope.bodyValues[$scope.targetField]) {
                        $scope.bodyValues[$scope.targetField] = {};
                    }
                    answer["filename"] = "NO ADJUNTO. " + answer.description;
                    answer["title"] = $scope.title
                    $scope.bodyValues[$scope.targetField][answer.id] = answer;


                    if (!$scope.txtFileNames[$scope.targetField]) {
                        $scope.txtFileNames[$scope.targetField] = {};
                    }
                    $scope.txtFileNames[$scope.targetField][answer.id] = "NO ADJUNTO. " + answer.description;

                    if (!$scope.txtImages[$scope.targetField]) {
                        $scope.txtImages[$scope.targetField] = {};
                    }
                    $scope.txtImages[$scope.targetField][answer.id] = true;;

                    if (!$scope.txtImagesSkip[$scope.targetField]) {
                        $scope.txtImagesSkip[$scope.targetField] = {};
                    }
                    $scope.txtImagesSkip[$scope.targetField][answer.id] = false;


                    if (!$scope.txtTitleImages[$scope.targetField]) {
                        $scope.txtTitleImages[$scope.targetField] = {};
                    }
                    $scope.txtTitleImages[$scope.targetField][answer.id] = true
                    var data = $scope.bodyItem[$scope.targetField].metadata.constraints.data;
                    var mainImage = true;
                    var check = $scope.txtTitleImages[$scope.targetField]
                    var values = Object.values(check);
                    if (values.length < data.length) { } else {
                        for (const item of values) {
                            if (item === false) {
                                mainImage = false;
                            }
                        }
                        if (mainImage) {
                            $scope.docsImage[$scope.targetField] = true;
                            var values = new Array();
                            var bodyValues = Object.values($scope.bodyValues[$scope.targetField])
                            for (const item of bodyValues) {
                                values.push(item);
                            }
                            $scope.bodyItem[$scope.targetField].metadata.defaultValue = JSON.stringify(values);
                        }
                    }

                }
            }, function (cancel) { });
    };

    $scope.getExtensions = function (exts) {
        var types = exts.split(",");
        var ouput = new Array();
        for (const type of types) {
            ouput.push("." + type);
        }
        var extensions = ouput.join(",");
        return extensions;

    }

    $scope.checkDefault = function (item) {
        return item === '';
    }


    $scope.getAudioSrc = function (bodyItem) {
        if (bodyItem.metadata.defaultValue != undefined && bodyItem.metadata.defaultValue != null && bodyItem.metadata.defaultValue != '') {
            $scope.hasAudio = true;
            return $sce.trustAsResourceUrl(esb + "/security" + bodyItem.metadata.defaultValue);
        } else {
            $scope.hasAudio = false;
            return "";
        }
    }
    $scope.parseImageJsonUrl = function (item) {
        var obj = ""
        try {
            obj = JSON.parse(item);
            return obj["url"];
        } catch (e) {

        }
        return "";

    }

    function getPosition() {
        return new Promise((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, reject)
        );
    }
    var gpsData = {}

    function setPositionOnItemGps(metadataObj) {
        getPosition()
            .then((position) => {

                $window.localStorage.setItem("locationPermission", "true");
                $scope.gpsDataPosition = position
                gpsData[metadataObj.instruction.gps.targets.permissionGranted] = true;
                gpsData[metadataObj.instruction.gps.targets.latitude] = position.coords.latitude;
                gpsData[metadataObj.instruction.gps.targets.longitude] = position.coords.longitude;
                var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + position.coords.latitude + "," + position.coords.longitude + "&key=AIzaSyCuHOsgmgIRKiBV9BAuh06wQN4Hb-lfV14&&sensor=true&callback=initMap";
                fetch(url)
                    .then(response => response.text())
                    .then(contents => {
                        var data = JSON.parse(contents);

                        if (data.results[0]) {

                            gpsData[metadataObj.instruction.gps.targets.address] = data.results[0].formatted_address;

                            for (var i = 0; i < data.results[0].address_components.length; i++) {
                                if (data.results[0].address_components[i].types[0] == "administrative_area_level_2")
                                    gpsData[metadataObj.instruction.gps.targets.city] = data.results[0].address_components[i].long_name;

                            }
                        }
                        $scope.formBodyItem.metadata.instruction = $scope.formBodyItem.metadata.instruction || {}
                        $scope.formBodyItem.metadata.instruction.gpsResult = gpsData;

                    }


                    );



            })
            .catch((err) => {
                console.error(err.message);
            });

    }
 
});
